import { Preferences } from './../config/preferences';

/**
 * User preferences
 */
export default {
  namespaced: true,
  state: {
    campaignActionsPageSize: 10,
    publishedCampaignsPageSize: 10,
    publishedCampaignActionsPageSize: 10,
    contactCommsPageSize: 10,
    conversationsLimit: 50,
    eventsPageSize: 10,
    qualifyPageSize: 10,
    emailActivityPageSize: 5,
    mediaPageSize: 10,
    navBarExpanded: true,
    shortCodesPageSize: 10,
    tasksPageSize: 10,
    tasksPreview: true,
    tasksRange: 'current',
    templatesSize: 10,
    videoLibraryPageSize: 10,
    vitalsRange: 7,
    contactsTableItemsPersistance : 10,
    scheduledsPageSize: 10,
    contactProfilePannelIsExpanded: false,
  },
  getters: {
    vitalsRange: state => state.vitalsRange,
    tasksRange: state => state.tasksRange,
    tasksPageSize: state => state.tasksPageSize,
    tasksPreview: state => state.tasksPreview,
    qualifyPageSize: state => state.qualifyPageSize,
  },
  mutations: {
    setPreference(state, { key, value }) {
      state[key] = value;
    },
    init(state) {
      const storedPrefs = localStorage.getItem(Preferences.LocalStorageKey);
      if (storedPrefs) {
        try {
          // try to hydrate state from local storage
          Object.assign(state, JSON.parse(storedPrefs));
        } catch (e) {
          // invalid preferences in local storage - discard and use default state
        }
      }
    },
  },
  actions: {
    updatePreference({ commit }, { key, value }) {
      commit('setPreference', { key, value });
    },
  },
};
